export const people = (state) => state.people;
export const team = (state) => state.people;
export const loading = (state) => state.loading;
